import { createBoundedUseStore, createStore } from "store/zustand/createStore";
import type { MassActionId, MassActionMetrics } from "@gs/core/domain/MassAction/MassAction";

export const massActionMetricsStore = createStore<Record<MassActionId, MassActionMetrics>>(
  "@domain/massActionMetrics",
  (set, get) => ({}),
);

export const useMassActionMetricsStore = createBoundedUseStore(massActionMetricsStore);
